import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const STYLES = { videoIframeContainer: { padding: '100% 0 0 0', position: 'relative', }, videoIframe: { position: 'absolute', top: "15%", left: 0, width: '100%', height: "60%" } }

const sheetId = '1ONxbH5drN17dV94b4XEMJIeDeYAlh_sJqSolSkVU9cU';
const sheetName = 'Events';

function AtlantaGalleryEvents() {

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSheetData = async () => {
      try {
        const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:json&sheet=${sheetName}`;
        const response = await fetch(url);
        const text = await response.text();
        const json = JSON.parse(text.substring(47).slice(0, -2));
        const rows = json.table.rows;

        const parsedEvents = rows.map(row => ({
          date: row.c[0]?.v || '',
          title: row.c[1]?.v || '',
          location: row.c[2]?.v || '',
          free: row.c[3]?.v || '',
          rsvpReq: row.c[4]?.v || ''
        }));

        const filtered = parsedEvents.filter(event => {
          const match = event.date.match(/^Date\((\d+),(\d+),(\d+)\)$/);
          if (!match) return false;
        
          const year = Number(match[1]);
          const month = Number(match[2]); // Already zero-indexed
          const day = Number(match[3]);
          const eventDate = new Date(year, month, day);

          const today = new Date();

          const startOfWeek = new Date(today);
          startOfWeek.setHours(0, 0, 0, 0);
          startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday

          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 6);
          endOfWeek.setHours(23, 59, 59, 999); // End of week

          console.log(event.date);


          return (
            eventDate >= startOfWeek &&
            eventDate <= endOfWeek
          );

        });

        setEvents(filtered);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching sheet data:', err);
        setLoading(false);
      }
    };

    fetchSheetData();
  }, []);

  if (loading) return <p>Loading events...</p>;
  if (events.length === 0) return <p>No events this week.</p>;

  return (
    <>
    <Container fluid className="home-section" id="home">
    
      <header>
        <p>Gallery Events Happening This Week</p>
      </header>

      <main>
        <ul>
        {events.map((event, index) => (
          <li key={index}>
            <strong>{event.title}</strong> — {event.date} @ {event.location}
          </li>
        ))}
        </ul>
      </main>
      <Container>
      </Container>
    </Container>
    <Container fluid>
  </Container>    
    </>

  );
}

export default AtlantaGalleryEvents;
